import React, { useState, useEffect, useRef } from 'react';
import Loader from '../Common/Loader';
import md5 from 'md5';
import axios from 'axios';
import HtmlParser from 'html-react-parser';
import BookingFilter from './BookingFilter';
// import { CSVLink } from 'react-csv';
import moment from 'moment-timezone';
import ResponsivePagination from 'react-responsive-pagination';
import ReactPaginate from 'react-paginate';

// import 'react-responsive-pagination/themes/classic-light-dark.css';

// const { convertArrayToCSV } = require('convert-array-to-csv');
import constants from '../../constants';
import { cookieStorageUtility, localStorageUtility } from '../../utils/utilityFunctions';
import { checkRole } from '../Common/CheckRole';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const hotelId = cookieStorageUtility.fetch('hotelId');
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const initialSearchParam = {
  channelId: 0,
  categoryMapStatus: '',
  hotelMapStatus: '',
  bookingId: '',
  hotelName: '',
  hotelId: '',
  checkIn: '',
  checkInTo: '',
  checkOut: '',
  checkOutTo: '',
  bookingDate: '',
  bookingDateTo: '',
  bookingStatus: '',
  countryId: '',
  cityId: '',
  cityName: ''
};

const BookingWrapper = () => {
  const [count, setCount] = useState(0);
  const [list, setList] = useState([]);
  const [ota, setOta] = useState([]);
  const [csv, setCsv] = useState([]);
  const [voucher, setVoucher] = useState('');
  const [show, setShow] = useState(false);
  const [card, setCard] = useState(false);
  const [showPopup, setShowPopup] = useState('');
  const [requestType, setRequestType] = useState('');
  const [bookingId, setBookingId] = useState(0);
  const [channelId, setChannelId] = useState(0);
  const [hotelIdState, setHotelIdState] = useState(0);
  const [cardDetails, setCardDetails] = useState({});
  const [userPass, setUserPass] = useState('');
  const [showUILoader, setShowUILoader] = useState(false);
  const csvRef = useRef();
  const [limit] = useState(20);
  const [maxWidth] = useState(5);
  const [showCard, setShowCard] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [searchParam, setSearchParam] = useState(initialSearchParam);

  useEffect(() => {
    // Only get OTA list on the first load
    getOTAList();
    
    // We don't need this dependency on pageNumber anymore
    // since we're handling the pagination in handlePageChange
    getBookingList();
    // eslint-disable-next-line
  }, []);

  const setMessageHandler = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => setFlag(false), 3000);
  };

  const handleAsyncCity = (selected) => {
    Object.keys(selected).forEach(id => {
      setSearchParam(prev => ({
        ...prev,
        cityId: selected[id].city_id,
        cityName: selected[id].state
          ? selected[id].city + ', ' + selected[id].state
          : selected[id].city
      }));
    });
  };

  const getOTAList = () => {
    axios(serverUrl + 'common/getotalist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    }).then(response => {
      if (response.status === 200) {
        setOta(response.data);
      } else {
        setMessageHandler('error', response.data.message);
      }
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const getBookingList = () => {
    setShowUILoader(true);    
    axios(serverUrl + 'booking/getbookinglist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId: hotelId,
        page: pageNumber,
        limit: limit,
        searchParam: searchParam
      }
    }).then(response => {
      if (response.data.status === 'success') {
        setList(response.data.data);
        setTotal(response.data.count);
      } else {
        setMessageHandler('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log("Error fetching booking list:", error);
      setMessageHandler('error', 'Failed to fetch booking list. Please try again.');
      setShowUILoader(false);
    });
  };

//   const download = () => {
//     const response = {};
//     response.data = JSON.parse(
//       '{"data":[{"hotel_mapped":1,"hotel_name":"oolKost Female Syariah near Universitas Negeri Yogyakarta (Minimum Stay 6 Nights)","channel_id":21237,"channel_hotel_id":"44267159","hotel_id":1,"channel_name":"Expedia","common_booking_id":"1730834777","status":"cancel","checkin":"2021-01-18","checkout":"2021-01-19","categories":["Linked Apartment"],"rateplans":["RatePlan Test 1"],"guest_name":"Itsna Iftayani","guest_email":"N/A","guest_mobile":"29103377","guest_address":null,"rooms":1,"currency":"IDR","total_rate":"91801.0","created_on":"2021-01-20 22:48:33","inventory_blocked":[1],"showCard":1,"no_show":0,"guest_count":[{"adult":1,"child":"0","extra_bed":0}]},{"hotel_mapped":0,"hotel_name":"Not Available","channel_id":21237,"channel_hotel_id":"46389799","hotel_id":0,"channel_name":"Expedia","common_booking_id":"1721522519","status":"new","checkin":"2020-12-19","checkout":"2020-12-20","categories":["DUMY"],"rateplans":["Not Available"],"guest_name":"Fachrun Absyi","guest_email":"N/A","guest_mobile":"2139730888","guest_address":null,"rooms":1,"currency":"IDR","total_rate":"198687","created_on":"2020-12-08 18:53:19","inventory_blocked":[1],"showCard":0,"no_show":0,"guest_count":[{"adult":null,"child":"0","extra_bed":2}]},{"hotel_mapped":0,"hotel_name":"Not Available","channel_id":21237,"channel_hotel_id":"27271692","hotel_id":0,"channel_name":"Expedia","common_booking_id":"13357395","status":"new","checkin":"2020-10-31","checkout":"2020-11-04","categories":["DUMY"],"rateplans":["Not Available"],"guest_name":"Etienne Beaulne-Dury","guest_email":"N/A","guest_mobile":"3331112","guest_address":null,"rooms":1,"currency":"CAD","total_rate":"951.61","created_on":"2020-09-29 20:13:56","inventory_blocked":[1],"showCard":1,"no_show":0,"guest_count":[{"adult":null,"child":"3","extra_bed":2}]}],"count":3,"status":"success","status_code":200,"timestamp":"2021-02-02 12:56:02"}'
//     );
//     var data = convertArrayToCSV(response.data.data);
//     setCsv(data);
//     if (csvRef.current && csvRef.current.link) {
//       csvRef.current.link.click();
//     }
//   };

  const showVoucher = (hotel_id, channelId, bookingId) => {
    setShowUILoader(true);
    axios(serverUrl + 'booking/getvoucher', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId: hotel_id, channelId: channelId, bookingId: bookingId }
    }).then(response => {
      if (response.status === 200) {
        setVoucher(response.data.data);
        setShow(true);
      } else {
        setMessageHandler('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const manageCard = (type, bookingId, channelId) => {
    // if (checkRole('credit_card_view')) {
      const identity = localStorageUtility.fetch('identity');
      if (type === 'show') {
        setCard(true);
        setBookingId(bookingId);
        setChannelId(channelId);
        setCardDetails({});
      } else if (type === 'auth') {
        setShowUILoader(true);
        if (userPass === '') {
          setMessageHandler('error', 'Please enter password.');
          setShowUILoader(false);
          return;
        }
        axios(serverUrl + 'users/cardauth', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            token: btoa(authUserId + '|' + encryptedToken)
          },
          data: {
            username: identity.username,
            userPass: md5(userPass).toString(),
            bookingId: bookingId,
            channelId: channelId
          }
        }).then(response => {
          if (response.data.status === 'success') {
            setCardDetails(response.data.cardDetails);
          } else {
            setMessageHandler('error', response.data.message);
          }
          setShowUILoader(false);
        }).catch(error => {
          setMessageHandler('error', error.data.error);
          setShowUILoader(false);
        });
      }
    // }
  };

  const manageNowShow = (requestType, bookingId, channelHotelId) => {
    if (requestType === 'noshow') {
      setShowPopup(requestType);
      setBookingId(bookingId);
      setHotelIdState(channelHotelId);
    } else if (requestType === 'submit') {
      setShowUILoader(true);
      axios(serverUrl + 'booking/nowshow', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { requestType: requestType, bookingId: bookingId, channelHotelId: hotelIdState }
      }).then(response => {
        if (response.data.status === 'success') {
          setCardDetails(response.data.cardDetails);
        } else {
          setMessageHandler('error', response.data.message);
        }
        setShowUILoader(false);
      }).catch(error => {});
    }
  };

  const setData = e => {
    const setName = e.target.name;
    const value = e.target.value;
    if (setName === 'userPass') {
      setUserPass(value);
    } else if (setName === 'requestType') {
      setRequestType(value);
    }
  };

  const renderBookingList = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        return (
          <div className="table_row border_t_1 border_color_1 text-start" key={id}>
            <div className="tabcel align_middle pad10">
              <div className="ovr m_b_5">
                {data.common_booking_id}
                <div className="ovr fnt12 margtop5 bld" title="Channel Name with Booking Status">
                  {data.channel_name} <span className="color4_2">({data.status})</span>
                </div>
              </div>
            </div>
            <div className="tabcel align_middle pad10">
              {data.hotel_name}
              <div className={`inline align_middle marg_left5 ${data.hotel_mapped === 1 ? 'hides' : ''}`}>
                <i
                  className="fa fa-info fnt12 cursor_p color5_2"
                  title={`Channel Hotel Id : ${data.channel_hotel_id} not mapped.Kindly block inventory.`}
                ></i>
              </div>
            </div>
            <div className="tabcel align_middle pad10">
              <div className="ovr m_b_5">Check-in : {data.checkin}</div>
              <div className="ovr m_b_5">Check-out : {data.checkout}</div>
            </div>
            <div className="tabcel align_middle pad10"> {data.rooms} </div>
            <div className="tabcel align_middle pad10">
              {Object.keys(data.categories).map(val => {
                return (
                  <div className="ovr marg_bottom5" key={val}>
                    Rooms {Number(Number(val) + 1)} : {data.categories[val]} ({data.rateplans[val]})
                    <div className={`inline align_middle marg_left5 ${data.inventory_blocked[val] === 1 ? 'hides' : ''}`}>
                      <i
                        className="fa fa-info fnt12 cursor_p color5_2"
                        title="Category mapping not found. Please Block inventory."
                      ></i>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="tabcel align_middle pad10">
              {Object.keys(data.guest_count).map(val => {
                return (
                  <div className="ovr m_b_5" key={val}>
                    Rooms {Number(Number(val) + 1)} : A ({data.guest_count[val].adult}), C({data.guest_count[val].child}) ,
                    EB ({data.guest_count[val].extra_bed})
                  </div>
                );
              })}
            </div>
            <div className="tabcel align_middle pad10">
              <div className="ovr m_b_5">Name: {data.guest_name}</div>
              <div className="ovr m_b_5">Email: {data.guest_email}</div>
              <div className="ovr m_b_5">Phone No. : {data.guest_mobile}</div>
            </div>
            <div className="tabcel align_middle pad10">
              {data.currency} : {data.total_rate}
            </div>
            <div className="tabcel align_middle pad10">{data.created_on}</div>
            <div className="tabcel align_middle pad10">
              <div className="row gutters-3 fnt16">
                {data.hotel_id !== 0 && <div className="col-xs-4 tc">
                  <div
                    className="inline align_middle"
                    title="Voucher"
                    onClick={() => showVoucher(data.hotel_id, data.channel_id, data.common_booking_id)}
                  >
                    <i className="fa fa-file-pdf-o"></i>
                  </div>{' '}
                </div>}
                 {data.showCard === 1 && checkRole('credit_card_view') && <div className="col-xs-4 tc">
                  <a
                    className="inline align_middle"
                    href="#"
                    title="Credit Card"
                    onClick={() => manageCard('show', data.common_booking_id, data.channel_id)}
                  >
                    <i className="fa fa-credit-card"></i>
                  </a>{' '}
                </div>}
              </div>
            </div>
          </div>
        );
      });
    }
  };

    const handlePageChange = (selectedPage) => {
    const newPageNumber = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    const newCounter = newPageNumber <= 1 ? 0 : (newPageNumber - 1) * limit;
    
    setPageNumber(newPageNumber);
    setCounter(newCounter);
    
    // Call getBookingList directly to fetch the data for the new page
    // Instead of calling searchBooking which has additional validation
    setTimeout(() => {
      getBookingList();
    }, 0);
  };

  const dateChange = (date, type) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    setSearchParam(prev => ({
      ...prev,
      [type]: newDate
    }));
  };

  const paramChange = (e, type) => {
    if (type === 'hotelName') {
      setSearchParam(prev => ({
        ...prev,
        hotelName: e.length > 0 ? e[0].hotel : '',
        hotelId: e.length > 0 ? e[0].hotel_id : ''
      }));
    } else {
      setSearchParam(prev => ({
        ...prev,
        [type]: e.target.value
      }));
    }
  };

  const searchBooking = () => {
    var flag = true;
    var msg = 'Please Select Criteria for search.';
    const sp = searchParam;
    if (sp.channelId > 0) flag = false;
    if (sp.categoryMapStatus !== '') flag = false;
    if (sp.hotelMapStatus !== '') flag = false;
    if (sp.bookingId !== '') flag = false;
    if (sp.hotelName !== '') flag = false;
    if (sp.bookingId !== '') flag = false;
    if (sp.checkIn !== '') flag = false;
    if (sp.checkInTo !== '') flag = false;
    if (sp.checkOut !== '') flag = false;
    if (sp.checkOutTo !== '') flag = false;
    if (sp.bookingDate !== '') flag = false;
    if (sp.bookingDateTo !== '') flag = false;
    if (sp.countryId !== '') flag = false;
    if (sp.cityId !== '') flag = false;
    if (sp.bookingStatus !== '') flag = false;

    if (flag) {
      setFlag(true);
      setType('error');
      setMessage(msg);
      setTimeout(() => setFlag(false), 5000);
    } else {
      setPageNumber(1);
      setCounter(0);
      getBookingList();
    }
  };

  const closeVoucher = () => {
    setVoucher('');
    setShow(false);
  };

  const reset = () => {
    setSearchParam(initialSearchParam);
    setPageNumber(1);
    setCounter(0);
    getBookingList();
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu text-start">MY BOOKING</div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      ) : (
        ''
      )}
      <BookingFilter
        params={searchParam}
        dateChange={dateChange}
        paramChange={paramChange}
        searchBooking={searchBooking}
        ota={ota}
        reset={reset}
        handleAsyncCity={handleAsyncCity}
      />
      <div className="container_fluid pad_lft_rht20 padtop25">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed text-start">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx150">OTA DETAIL</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx220">HOTEL</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">STAY PERIOD</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx80">ROOM(S)</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx220">ROOMS DETAILS</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx220">PAX</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx180">GUEST DETAILS</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx120">TOTAL AMOUNT</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx120">BOOKED ON</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">ACTION</div>
              </div>
              {renderBookingList()}
            </div>
          </div>
          {total === 0 && !showUILoader ? (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Booking Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No Booking Found</div>
            </div>
          ) : (
            ''
          )}
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageChange}
              pageRangeDisplayed={3}
              pageCount={Math.ceil(total / limit)}
              previousLabel="< Prev"
              forcePage={pageNumber - 1} // Convert from 1-based to 0-based for ReactPaginate
              containerClassName="pagination"
              activeClassName="active"
              marginPagesDisplayed={1}
              disabledClassName="disabled"
            />
          </div>
        ) : (
          ''
        )}
      </div>

      <div className={`modal_wrap posabso ${show ? '' : 'hides'}`}>
        <div className="modal_overlay transbg1">&nbsp;</div>
        <div className="pop_colum">
          <div className="pop_inner pad30">
            <div className="apndwrap booking-voucher container shwd2 bg1 pad30 round5 ovr zIndex999">
              <div
                className="close_popup facnt full-round bgcolr6 text-start"
                onClick={closeVoucher}
              >
                <i className="fa fa-times txtcolr1"></i>
              </div>
              <div className="wrapper booking-voucher-content text-start">{HtmlParser(voucher)}</div>
            </div>
          </div>
        </div>
      </div>

      <div className={`modal_wrap posfixed ${card ? '' : 'hides'}`}>
        <div className="modal_overlay transbg1">&nbsp;</div>
        <div className="pop_colum">
          <div className="pop_inner">
            <div className="apndwrap wdhpx400 shwd2 bg1 pad30 round5 ovr zIndex999">
              <div
                className="close_popup facnt full-round bgcolr6"
                onClick={() => setCard(false)}
              >
                <i className="fa fa-times txtcolr1"></i>
              </div>

              <div className={`wrapper ${Object.keys(cardDetails).length === 0 ? '' : 'hides'}`}>
                <div className="cover marg_bottom10">
                  <div className="cover marg_bottom15">
                    <div className="ovr marg_bottom5">
                      Confirm Password <span className="color5">*</span>
                    </div>
                    <div className="frm border_all_1 border_color_1" id="confirmbd">
                      <input
                        className="input pad_lft_rht5"
                        type="password"
                        onChange={setData}
                        name="userPass"
                        value={userPass}
                      />
                    </div>
                  </div>

                  <div className="cover">
                    <div className="inline">
                      <input
                        value="Get Card Details"
                        className="btn1 pad_top_bot7 pad_lft_rht20 tc fnt16 cursor_p"
                        onClick={() => manageCard('auth', bookingId, channelId)}
                        type="button"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={`wrapper ${Object.keys(cardDetails).length > 0 ? '' : 'hides'}`}>
                <div className="cover">
                  <div className="table_col table_fixed">
                    <div className="table_row">
                      <div className="tabcel align_middle pad10 wdhpx120 bld">Card Name</div>
                      <div className="tabcel align_middle wdhpx30 tc bld"> : </div>
                      <div className="tabcel align_middle pad10">{cardDetails.name}</div>
                    </div>
                    <div className="table_row">
                      <div className="tabcel align_middle pad10  bld">Card Number</div>
                      <div className="tabcel align_middle tc bld"> : </div>
                      <div className="tabcel align_middle pad10">{cardDetails.cardNumber}</div>
                    </div>
                    <div className="table_row">
                      <div className="tabcel align_middle pad10  bld">Expire Date</div>
                      <div className="tabcel align_middle  tc bld"> : </div>
                      <div className="tabcel align_middle pad10">{cardDetails.expireDate}</div>
                    </div>
                    <div className="table_row">
                      <div className="tabcel align_middle pad10  bld">Card Type</div>
                      <div className="tabcel align_middle  tc bld"> : </div>
                      <div className="tabcel align_middle pad10">{cardDetails.cardType}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className={`modal_wrap posfixed ${showPopup === 'noshow' ? '' : 'hides'}`}>
        <div className="modal_overlay transbg1">&nbsp;</div>
        <div className="pop_colum">
          <div className="pop_inner">
            <div className="apndwrap wdhpx400 shwd2 bg1 pad30 round5 ovr zIndex999">
              <div
                className="close_popup facnt full-round bgcolr6"
                onClick={() => setShowPopup('')}
              >
                <i className="fa fa-times txtcolr1"></i>
              </div>

              <div className="wrapper">
                <div className="cover marg_bottom10">
                  <div className="cover marg_bottom15">
                    <label className="ovr marg_bottom7 bld">Select Type </label>
                    <div className="frm border_all_1 border_color_1 border_all_1 border_color_1border_all_1 border_color_1">
                      <span className="ficon">
                        <i className="fa fa-chevron-down"></i>
                      </span>
                      <select
                        name="requestType"
                        className="input pad_lft_rht10"
                        value={requestType}
                        onChange={setData}
                      >
                        <option value="credit_card_invalid">Credit Card Invalid</option>
                        <option value="credit_card_cancel">Credit Card Cancel</option>
                        <option value="nowshow">Noshow</option>
                      </select>
                    </div>
                  </div>

                  <div className="cover">
                    <div className="inline">
                      <input
                        value="Submit"
                        className="btn1 pad_top_bot7 pad_lft_rht20 tc fnt16 cursor_p"
                        onClick={() => manageNowShow('submit', 0, 0)}
                        type="button"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BookingWrapper;